"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fluid = void 0;
const lib_1 = require("../lib");
exports.Fluid = (0, lib_1.createUtility)('fluid', ({ fluid }) => {
    return fluid ? `w--100` : null;
});
//# sourceMappingURL=fluid.js.map